import type { BankInformation } from '@/services/payment/payment.types';

export const getBankInformation = (paymentInformation?: BankInformation) => {
  const {
    bankTypeLabel = '',
    bankName = '',
    branchName = '',
    accountNumber = '',
    accountName = '',
  } = paymentInformation || {};

  return [
    {
      id: 'bankType',
      label: 'paymentManagement.adminPaymentSetup.adminBankInfo.bankType',
      defaultLabel: 'Bank Type',
      value: bankTypeLabel,
    },
    {
      id: 'bankName',
      label: 'paymentManagement.adminPaymentSetup.adminBankInfo.bankName',
      defaultLabel: 'Bank Name',
      value: bankName,
    },
    {
      id: 'branchName',
      label: 'paymentManagement.adminPaymentSetup.adminBankInfo.branchName',
      defaultLabel: 'Branch Name',
      value: branchName,
    },

    {
      id: 'accountNumber',
      label: 'paymentManagement.adminPaymentSetup.adminBankInfo.accNum',
      defaultLabel: 'Account Number',
      value: accountNumber,
    },

    {
      id: 'accountName',
      label: 'paymentManagement.adminPaymentSetup.adminBankInfo.accHolderName',
      defaultLabel: 'Account Name',
      value: accountName,
    },
  ];
};
